import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { IChefHeaderOptionsInterface } from 'chef-common/src/lib/chef-header';
import { Subscription } from 'rxjs';
import { IActivateUserPayload, IGenericResponse, IUserData } from '@interfaces/common';
import { IChefLoaderOptionsInterface } from 'chef-common/src/lib/chef-loader';
import { IChefFooterOptionsInterface } from 'chef-common/src/lib/chef-footer';
import { SiteStorage, SubscriptionStatus, SiteText, SiteCookies } from '@constants/global';
import { UtilityService } from '@services/utility.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgeModalComponent } from '@modals/age-modal/age-modal.component';
import { NotificationService } from '@services/notification.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'account';
  headerOptions: IChefHeaderOptionsInterface = {
    isLoggedIn: false
  };
  loaderOptions: IChefLoaderOptionsInterface = {
    loaderName: 'chefLoader',
    loaderMsg: 'Please wait',
    isLoaderFullScreen: true
  };
  footerOptions: IChefFooterOptionsInterface = {
    isLoggedIn: false
  };
  isAccountDeactivated: boolean = false;
  showPageNotification: string | undefined = '';
  activeRoute: string = '';

  private subscription: Subscription = new Subscription();

  constructor(private auth: AuthService, private user: UserService, private router: Router, private utility: UtilityService, private modalService: NgbModal, private notification: NotificationService) { 

    /**
     * Send the page view to google analytics
     */
    /* this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (window as any).ga('set', 'page', event.urlAfterRedirects);
        (window as any).ga('send', 'pageview');
      }
    }); */
  }

  ngOnInit(): void {
    const checkLoginSub = this.user.getUserDataObservable().subscribe(
      (value: IUserData) => {
        this.headerOptions.isLoggedIn = value.isLoggedIn ? value.isLoggedIn : false;
        this.footerOptions.isLoggedIn = value.isLoggedIn ? value.isLoggedIn : false;

        this._addHeaderOptions(value);
        this._addFooterOptions(value);
        this.isAccountDeactivated = (this.user.getUserInfo().userInfo && (this.user.getUserInfo().userInfo?.subscription_status !== SubscriptionStatus.ACTIVE && this.user.getUserInfo().userInfo?.subscription_status !== SubscriptionStatus.PAUSED)) ? true : false;
        this.showPageNotification = this.user.getUserInfo().userInfo && this.user.getUserInfo().siteInfo && this.user.getUserInfo().siteInfo?.notification ? this.user.getUserInfo().siteInfo?.notification : '';
        //this._checkUserSubscriptionStatus();
      });
    this.subscription.add(checkLoginSub);

    if(this.user.getUserInfo().isLoggedIn){
      this.headerOptions.isLoggedIn = true;
      this.footerOptions.isLoggedIn = true;

      const userInfo = this.user.getUserInfo();
      this._addHeaderOptions(userInfo);
      this._addFooterOptions(userInfo);
      this.isAccountDeactivated = (this.user.getUserInfo().userInfo && (this.user.getUserInfo().userInfo?.subscription_status !== SubscriptionStatus.ACTIVE && this.user.getUserInfo().userInfo?.subscription_status !== SubscriptionStatus.PAUSED)) ? true : false;
      this.showPageNotification = this.user.getUserInfo().userInfo && this.user.getUserInfo().siteInfo && this.user.getUserInfo().siteInfo?.notification ? this.user.getUserInfo().siteInfo?.notification : '';
      //this._checkUserSubscriptionStatus();
    }else{
      this.showPageNotification = '';
    }

    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.activeRoute = ev.url.split('/')[1];
        if(ev.url.indexOf('profile') > 0){
          this.displayAgeModal();
        }
      }
    });

    // Handle encoded query string in initial URL (e.g., /my-ratings%3F_kx=...)
    const rawUrl = window.location.pathname;
    if (rawUrl.includes('%3F')) {
      // Decode and split into path and query
      const decodedUrl = decodeURIComponent(rawUrl);
     
      // Use Router to navigate to the correct URL
      this.router.navigateByUrl(decodedUrl);
      return; // Prevent further initialization until redirect
    }
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  doLogout(){
    this.auth.logout();
  }

  changeRoute(newRoute: string){
    this.router.navigate(['/'+ newRoute ]);
  }

  private _addHeaderOptions(data: IUserData){
    this.headerOptions.siteInfo = data.siteInfo;
    this.headerOptions.userInfo = data.userInfo;
  }
  private _addFooterOptions(data: IUserData){
    this.footerOptions.siteInfo = data.siteInfo;
    this.footerOptions.userInfo = data.userInfo;
  }

  displayAgeModal(){
    if(this.utility.getCookie(SiteCookies.ORDERPLACED) !== 'true' && !this.user.getUserInfo().userInfo?.age && this.utility.getFromBrowserStorage(SiteStorage.ISAGEMODALVIEWED) !== 'true'){
        this.modalService.open(AgeModalComponent, {size: 'md'});
        this.utility.setInBrowserStorage(SiteStorage.ISAGEMODALVIEWED, 'true');
    }
  }

  reactivateUser(){
    /* const payload: IActivateUserPayload = {
      action: 'activate'
    };
    const subs = { 
      next: (response: IGenericResponse) => {
        if(response.response.code === '0000'){
          this.user.updateUserInfo('subscription_status', SubscriptionStatus.ACTIVE);
          this.notification.showNotification('success', response.response.message);
        }else{
          this.notification.showNotification('error', response.response.message);
        }
      },
      error: (e: any) =>{
        console.log(e);
        this.notification.showNotification('error', SiteText.TECHNICAL_ERROR);
      }};
    this.utility.sendRequest<IGenericResponse>(environment.reactivateUser, payload).subscribe(subs); */
    this.router.navigate(['/change-subscription']);
  }

  /* private _checkUserSubscriptionStatus(){
    if(this.user.getUserInfo().userInfo?.subscription_status === SubscriptionStatus.CANCELLED){
      this.notification.showNotification('error', SiteText.SESSION_ERROR);
      this.auth.logout();
    }
  } */
}
